import * as def from '@/definitions'
import { Document } from '@/model/document2/document';

// アプリケーション状態管理クラス

export class ApplicationState
{
    // フロー
    // 0: 通常
    // 1: 差し込み(テンプレートから選択)
    // 2: 差し込み(デザインから選択)
    // 3: 差し込み(ファイル読み込み)
    public flowMode : number = 0;
    
    // 編集モード
    // 0: 通常
    // 1: 変形 - 通常
    // 2: 変形 - 操作点追加
    // 3: 変形 - 操作点削除
    // 4: トリミング
    public editMode : number = 0;

    // トリミングを呼び出したレイヤーID
    public lastTrimLayerId : string = "";

    // 曲線編集モード
    // *曲線は常に変形中状態になるので、別プロパティで管理する
    // 0: 通常
    // 2: 操作点追加
    // 3: 操作点追加
    public curveEditMode : number = 0;

    // インプットモード
    // 0: なし
    // 1: インプット中
    public inputMode : number = 0;

    // モーダルダイアログ
    // 0: 表示なし
    // 1: モーダル表示中
    public modalMode : number = 0;

    // ドロップダウンリスト
    // 0: 表示なし
    // 1: 表示中
    public dropdownListMode : number = 0;
    
    // 初期設定
    public startProductCode = "";
    public startPaperRotate = 0;
    public startTemplateId = 0;
    public startKeepRatio = false;
    public startDesignRotate = 0;
    public startPath = "";

    // mobile:
    // レイアウトコピーモード
    // 0: なし
    // 1: コピー中
    public layoutCopyMode = 0;
    public layoutCopyPage = 0;
    public layoutCopyPosition = 0;
    public layoutCopyReverse = false;

    // トリミング設定項目
    public trimSettingX = 0;
    public trimSettingY = 0;
    public trimSettingWidth = 100;
    public trimSettingHeight = 100;

    // DL:
    // 読み込み準備中のドキュメントデータ
    public preloadDocument : Document | null = null;

    // debug
    // 0 : 使わない
    // 1 : 文字のレンダリングをシンプルにする
    // 2 : 移動中のみレンダリングしない
    public useSimpleText = 0;
    // レイヤー移動モード
    // 0 : 移動なし
    // 1 : 移動中
    // 2 : 拡大縮小中
    // 3 : 回転中
    public moveLayerMode = 0;
    public moveLayerId = "";
}